import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import NotFoundLayout from "../../views/notfound/NotFoundLayout";
import Cookies from "js-cookie";
import { RouteItemConfig } from "../../routes/models";
import { useCookieContext } from "../../contexts";
import WelcomePageView from "views/welcomePage/WelcomePageView";
import React from "react";
import { hasRequiredRole } from "components/blocks/AuthGuard";

interface SwitchRouteProps {
  routes: Array<RouteItemConfig>;
}

// Component to handle redirect with current location
const RedirectToLogin: React.FC = () => {
  const location = useLocation();
  return <Navigate to={`/account/login?redirectRoute=${location.pathname}`} replace />;
};

export const SwitchRoute: React.FC<SwitchRouteProps> = ({ routes }) => {
  const { userSession } = useCookieContext();
  const getRecursion = (value: RouteItemConfig): React.ReactNode[] => {
    const nestedRoutes: React.ReactNode[] = [];


    // If there are sub-menu items, recursively call getRecursion
    if (value.subMenu && value.subMenu.length > 0) {
      const userRole = userSession?.roles || [];
      const defaultRoute = value.subMenu.find((sub) => sub.default) || value.subMenu.filter(f=>hasRequiredRole(userRole, f.roles))[0];
      // Add a redirect route to the first sub-menu path
      if(defaultRoute)
        nestedRoutes.push(
            <Route
                path={value.path}
                element={<Navigate to={defaultRoute.path} replace />}
                key={`redirectRoute${value.path}`}
            />,
        );

      // Recursively generate nested routes for each sub-menu item
      value.subMenu.forEach((subValue) => {
        nestedRoutes.push(...getRecursion(subValue));
      });

      // Wrap nested routes under the main route with layout component
      return [
        <Route path={value.path} element={<value.component />} key={`layoutRoute${value.path}`}>
          {nestedRoutes}
        </Route>,
      ];
    } else {
      // Generate a unique key for each route
      const key = Math.floor(Math.random() * 1000);
      // Authorization check
      const requiresAuth = value.authorize;
      const userRole = userSession?.roles || [];
      const hasRequiredRoles =   hasRequiredRole(userRole, value.roles);
      // Check if the route requires authorization
      if (value.authorize) {
        nestedRoutes.push(
            ((localStorage.getItem("Session") || userSession)&& hasRequiredRoles ) ? (
                <Route path={value.path} element={<value.component />} key={`privateRoute${key}`} />
            ) : ((localStorage.getItem("Session") || userSession) && !hasRequiredRoles) ?
                (<Route path={value.path} element={<NotFoundLayout />} key={`redirectRoute${key}`} />):
                (<Route path={value.path} element={<RedirectToLogin />} key={`redirectRoute${key}`} />)

        );
      } else {
        nestedRoutes.push(<Route path={value.path} element={<value.component />} key={`publicRoute${key}`} />);
      }

      return nestedRoutes;
    }
  };

  const renderDefaultRoute = () => {
    return <Route path="/" element={<WelcomePageView />} key={`defaultRoute`} />;
  };

  return (
      <>
        {routes.length > 0 && (
            <Routes>
              {renderDefaultRoute()}
              {routes.map((routeItem) => {
                return getRecursion(routeItem);
              })}
              <Route path="*" element={<NotFoundLayout />} />
            </Routes>
        )}
      </>
  );
};
